// Convert integer cents to a display-ready decimal string.
// No currency symbol — the caller adds it in JSX (e.g. `£{formatCents(1999)}`).
export function formatCents(cents: number): string {
  return (cents / 100).toFixed(2)
}
